import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Bell, Search, HelpCircle } from 'lucide-react';
import { Input } from '../ui/input';

export default function TopBar({ admin }) {
  const { user } = useAuth();
  return (
    <header className="sticky top-0 z-20 h-[60px] bg-white/85 backdrop-blur-md border-b border-slate-200/70 px-6 flex items-center gap-4">
      <div className="relative flex-1 max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-[15px] w-[15px] text-slate-400" strokeWidth={2} />
        <Input
          placeholder={admin ? 'Search hosts, bookings, properties…' : 'Search bookings, guests…'}
          className="pl-9 h-9 bg-slate-50/80 border-slate-200/80 text-[13px] placeholder:text-slate-400 rounded-lg focus-visible:ring-teal-500/40 focus-visible:border-teal-500/60"
        />
        <kbd className="hidden md:inline-flex absolute right-2 top-1/2 -translate-y-1/2 items-center gap-0.5 px-1.5 h-5 rounded border border-slate-200 bg-white text-[10px] font-mono text-slate-500">
          ⌘K
        </kbd>
      </div>
      <div className="ml-auto flex items-center gap-1.5">
        <button className="h-9 w-9 grid place-items-center rounded-lg text-slate-500 hover:bg-slate-100 hover:text-slate-900 transition-colors">
          <HelpCircle className="h-[15px] w-[15px]" strokeWidth={1.75} />
        </button>
        <button className="h-9 w-9 grid place-items-center rounded-lg text-slate-500 hover:bg-slate-100 hover:text-slate-900 relative transition-colors">
          <Bell className="h-[15px] w-[15px]" strokeWidth={1.75} />
          <span className="absolute top-2 right-2 h-1.5 w-1.5 bg-teal-500 rounded-full ring-2 ring-white" />
        </button>
        <div className="pl-3 ml-1.5 border-l border-slate-200 flex items-center gap-2.5">
          <img src={user?.avatar} className="h-8 w-8 rounded-full object-cover ring-1 ring-slate-200" alt="" />
          <div className="hidden sm:block">
            <div className="text-[13px] font-medium text-slate-900 leading-tight tracking-tight">{user?.name}</div>
            <div className="text-[10.5px] text-slate-500 leading-tight capitalize mt-0.5">{user?.role?.replace('_', ' ')}</div>
          </div>
        </div>
      </div>
    </header>
  );
}
